import { MissionToStaff } from '../../lib/types/models/mission-to-staff/mission-to-staff'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type AddStaffsToMissionInput = {
  id: number
  staffIds: number[]
}

export function addStaffsForMission(input: AddStaffsToMissionInput) {
  const { id, staffIds } = input
  return restApiClient
    .url(constructApiUrl(API.missions.addStaffsToMission.url, { id }))
    .post<MissionToStaff>({ staffIds })
}
